import { render, staticRenderFns } from "./TrainingTypeDialog.vue?vue&type=template&id=4d4e2e47&scoped=true&"
import script from "./TrainingTypeDialog.vue?vue&type=script&lang=js&"
export * from "./TrainingTypeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4e2e47",
  null
  
)

export default component.exports